import * as React from 'react';

const ShieldFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.48 14.813c-.922-.59-2.376-1.623-3.59-2.93C2.661 10.56 1.776 9.06 1.776 7.528c0-.67-.013-3.213-.02-4.648 0-.064.024-.136.09-.206a.53.53 0 0 1 .287-.154c1.052-.192 2.148-.61 3.11-.977l.253-.096C6.583 1.035 7.412.75 8 .75s1.417.285 2.504.697l.253.096c.962.367 2.058.785 3.11.977a.53.53 0 0 1 .288.154c.066.07.09.142.09.206-.008 1.435-.021 3.979-.021 4.648 0 1.533-.885 3.032-2.114 4.355-1.214 1.308-2.668 2.34-3.59 2.93a.95.95 0 0 1-1.04 0Z"
  }
));
ShieldFilled16.Size = 16;
ShieldFilled16.Title = "ShieldFilled";

export { ShieldFilled16 as default };
